<template>
  <div class="reports__view">
    <tab-navigation-panel :tabs="tabs" />
    <router-view />
  </div>
</template>

<script>
import TabNavigationPanel from "@/components/TabNavigationPanel.vue";
import { mapGetters } from 'vuex';

export default {
  name: "configurationusertop-view",
  components: { TabNavigationPanel },
  data: () => ({
    tabs: [
      { label: "Mine grupper", name: "My-Groups" },
    ],

  }),
  computed: {
    ...mapGetters('groupTemplateStore', ['isGroupTemplateSimulating']),

  },
  watch: {
    'isGroupTemplateSimulating'(newValue) {
      this.tabs.find(q => q.name === "Disposition").override = newValue;
    }
  }
}
</script>


<style lang="scss">
.reports__view {
  .reports__navigation {
    background-color: $panel;
    height: 44px;
    display: flex;
    flex-flow: row wrap;
    align-content: center;
    padding: 0 12px;
  }

  .reports__subheader {
    background-color: $panel;
    padding: 5px 12px;
    height: 62px;

    display: flex;
    flex-flow: row wrap;
    gap: 5px;
    
    .datepicker {
      input {
        height: 30px !important;
        padding-top: 1px;
        padding-bottom: 2px;
      }
    }
    .ctrl-button {
      width: 100%;
    }
  }

  .field:not(:last-child) {
    margin-bottom: .2em;
  }
  label {
    margin-bottom: initial;
    font-size: .75em;
    font-weight: 600;
    &:not(:last-child) {
      margin-bottom: initial;
    }
  }
}
</style>

